import {
  CircularProgress,
  FormControlLabel,
  Radio,
  RadioGroup,
} from "@mui/material";
import { Fragment, useEffect, useState } from "react";
import { Select as AntSelect, Switch } from "antd";
import { useTranslation } from "react-i18next";
import {
  getSettingPreferences,
  updateSettingPreference,
} from "../../services/orgService";
import { CaretDownOutlined } from "@ant-design/icons";
import { toastMessage } from "../../helper";
import { CURRENCY, SETTING_PREFERENCE_TYPE } from "../../constants/enums";
import { FastForward } from "@mui/icons-material";
import { getEmissionCurrencyService } from "../../services/emissionService";

const OrganisationPreference = () => {
  const { Option } = AntSelect;
  const { t, i18n } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const [financialyear, setfinancialyear] = useState([
    { id: 1, name: "Feb to Jan", value: "2 to 1", isSelected: false },
    { id: 2, name: "March to Feb", value: "3 to 2", isSelected: false },
    { id: 3, name: "April to March", value: "4 to 3", isSelected: false },
    { id: 4, name: "May to April", value: "5 to 4", isSelected: false },
    { id: 5, name: "Jun to May", value: "6 to 5", isSelected: false },
    { id: 6, name: "Jul to Jun", value: "7 to 6", isSelected: false },
    { id: 7, name: "Aug to Jul", value: "8 to 7", isSelected: false },
    { id: 8, name: "Sep to Aug", value: "9 to 8", isSelected: false },
    { id: 9, name: "Oct to Sep", value: "10 to 9", isSelected: false },
    { id: 10, name: "Nov to Oct", value: "11 to 10", isSelected: false },
    { id: 11, name: "Dec to Nov", value: "12 to 11", isSelected: false },
  ]);
  const [value, setValue] = useState("");
  const [managementReports, setManagementReports] = useState<any>([]);
  const [gwpVersion, setGwpVersion] = useState<any>("ar6");
  const managementOptions = [
    { id: 1846, name: "Category Wise Breakdown" },
    { id: 1932, name: "Activity Wise - CO2e Breakdown" },
    { id: 3051, name: "Activity Wise - Data Breakdown" },
  ];

  const frameworkOptions = [
    { id: 460, name: "ISO 14064-1" },
    { id: 10662, name: "GHG Protocol" },
  ];
  const [selectedIds, seSelectedIds] = useState<any>([]);
  const [frameworkReports, setFrameworkReports] = useState<any>([
    {
      id: 460,
      name: "ISO 14064-1",
    },
  ]);
  const [settingsData, setSettingsData] = useState<any>();
  const [currencies, setCurrencies] = useState<any>([]);
  const [currency, setCurrency] = useState(CURRENCY.CURRENCY_49);
  const [allocationFacility, setAllocationFacility] = useState<any>();
  const [facilitiesList, setFacilitiesList] = useState<any[]>();
  // const [emailAuthEnabled, setEmailAuthEnabled] = useState<boolean>(false);
  const validateSettingsForm = () => {
    const selectedFinancialYear = financialyear.filter(
      (each: any) => each.isSelected
    );
    return (
      ((value === "true" ? true : false) || selectedFinancialYear.length > 0) &&
      managementReports.length > 0
    );
  };
  useEffect(() => {
    setFacilitiesList(
      JSON.parse(localStorage.getItem("businessUnits") || "[]")
    );
    let defaultUnit = JSON.parse(
      localStorage.getItem("businessUnits") || "[]"
    ).filter((unit: any) => unit.code.substr(-2) == "F1")[0];
    if (defaultUnit) {
      setAllocationFacility(defaultUnit.id);
    }
    getSettingPreferences(true).then((res) => {
      setSettingsData(res.data);
      if (res.data?.companyPreference?.allocation_facility) {
        setAllocationFacility(res.data.companyPreference.allocation_facility);
      }
      let fwReport = JSON.parse(res.data.companyPreference.reports)
        .framework[0];
      setFrameworkReports(
        frameworkOptions.filter((item) => item.id == fwReport)
      );
      setGwpVersion(res.data?.companyPreference.gwp_version);
      const yearName = res.data.companyPreference.financial_year;
      if (yearName) {
        let temp = financialyear;
        temp.forEach((eachYear: any) => {
          if (eachYear.value === yearName) {
            eachYear.isSelected = true;
          } else {
            eachYear.isSselected = false;
          }
        });
        setfinancialyear(temp);
      }
      // res.data.companyPreference.email_auth_enabled &&
      //   setEmailAuthEnabled(true);
      const reqManagement = res.data.reports.filter((each: any) =>
        [1846, 1932, 3051].includes(each.id)
      );
      setManagementReports([...reqManagement]);
      setCurrency(res.data.companyPreference.currency);
    });
  }, []);

  useEffect(() => {
    settingsData &&
      setValue(String(settingsData.companyPreference.is_calendar_year));
  }, [settingsData]);

  useEffect(() => {
    const temp = managementReports.map((each: any) => {
      return each.id;
    });
    seSelectedIds(temp);
  }, [managementReports]);
  useEffect(() => {
    getEmissionCurrencyService().then((res: any) => {
      setCurrencies([...res.data]);
    });
  }, []);

  const onChangeCurrency = (e: any) => {
    if (e) {
      setCurrency(e);
    }
  };
  const onChangeObjective = (event: any) => {
    let temp = JSON.parse(JSON.stringify(financialyear));
    temp.forEach((eachyear: any) => {
      eachyear.isSelected = false;
    });
    setfinancialyear(temp);
    setValue(event.target.value);
  };
  const handleDropDowns = (e: any, type: string) => {
    if (type === SETTING_PREFERENCE_TYPE.YEAR) {
      let temp = JSON.parse(JSON.stringify(financialyear));
      temp.forEach((eachyear: any) => {
        if (eachyear.value === e) {
          eachyear.isSelected = true;
        } else {
          eachyear.isSelected = false;
        }
      });
      setfinancialyear(temp);
    } else if (type === SETTING_PREFERENCE_TYPE.CARBON_FRAMEWORK) {
      const reqFramework = frameworkOptions?.filter(
        (each: any) => each.id === e
      );
      setFrameworkReports(reqFramework);
    } else if (SETTING_PREFERENCE_TYPE.MANAGEMENT_REPORTS) {
      const reqManagement = e.map((eachevent: any) => {
        return managementOptions.filter(
          (each: any) => each.id === eachevent
        )[0];
      });
      setManagementReports(reqManagement);
    }
  };
  const handleGWPVersionChange = (event: any) => {
    setGwpVersion(event);
  };
  const handleSettingsSave = () => {
    setIsLoading(true);
    const selectedFinancialYear = financialyear.filter(
      (each: any) => each.isSelected
    );
    const reqData = {
      gwpVersion: gwpVersion,
      id: settingsData.companyPreference.id,
      financialYear:
        selectedFinancialYear.length > 0 ? selectedFinancialYear[0].value : "",
      isCalendarYear: selectedFinancialYear.length > 0 ? false : true,
      allocationFacility: allocationFacility,
      // emailAuthEnabled,
      reports: {
        framework: frameworkReports.map((each: any) => {
          return each.id;
        }),
        management: managementReports.map((each: any) => {
          return each.id;
        }),
      },
      currency: currency,
    };
    updateSettingPreference(reqData).then(() => {
      localStorage.setItem(
        "protocol",
        frameworkReports[0].name.startsWith("ISO") ? "iso" : "ghg"
      );
      toastMessage("Data updated successfully", "success");
      setIsLoading(false);
    });
  };

  return (
    <Fragment>
      <div
        style={{ height: "100%", position: "relative" }}
        className="pw-settings-main h-100v w-full flex flex-col"
      >
        <div
          className="pw-all-fileds-settings w-full"
          style={{ overflow: "auto", height: "90%" }}
        >
          <div>
            <div className="pw-company-name flex flex-col gap-y-3">
              <div className="pw-text-neutral-600 pw-font-14px">
                {t("Carbon reporting period")}
              </div>
              <div className="flex flex-col">
                <RadioGroup
                  aria-labelledby="demo-controlled-radio-buttons-group"
                  name="radio"
                  value={value}
                  onChange={onChangeObjective}
                  className="!flex !flex-col \"
                >
                  <FormControlLabel
                    value={true}
                    control={<Radio />}
                    label={t("Calendar year - Default")}
                  />
                  <FormControlLabel
                    value={false}
                    control={<Radio />}
                    label={t("Financial year - Define")}
                  />
                </RadioGroup>
              </div>
              {value === "false" && (
                <div className="flex items-center ml-6">
                  <div>
                    <AntSelect
                      suffixIcon={<CaretDownOutlined />}
                      className="pw-input-field-settings pw-width-20"
                      onChange={(e) => handleDropDowns(e, "year")}
                      placeholder="Select Year"
                      value={
                        financialyear?.find((each: any) => each.isSelected)
                          ?.name
                      }
                    >
                      {financialyear?.map(
                        ({
                          name,
                          id,
                          value,
                        }: {
                          name: String;
                          id: number;
                          value: String;
                        }) => (
                          <Option
                            key={id}
                            value={value}
                            className="pw-menu-item"
                          >
                            {name}
                          </Option>
                        )
                      )}
                    </AntSelect>
                  </div>
                </div>
              )}
            </div>
            <div className="pw-company-name flex flex-col gap-y-3 mt-10">
              <div className="pw-text-neutral-600 pw-font-14px">
                {t("Carbon reporting framework")}
              </div>
              <AntSelect
                suffixIcon={<CaretDownOutlined />}
                className="pw-input-field-settings pw-width-30"
                value={frameworkReports[0]?.name}
                notFoundContent={null}
                onChange={(e) => handleDropDowns(e, "carbon framework")}
              >
                {frameworkOptions.map((each: any) => {
                  return (
                    <Option value={each.id} key={each.id}>
                      {each.name}
                    </Option>
                  );
                })}
              </AntSelect>
            </div>
            <div className="pw-company-name flex flex-col gap-y-3 mt-10">
              <div className="pw-text-neutral-600 pw-font-14px">
                {t("Management reports")}
              </div>
              <AntSelect
                suffixIcon={<CaretDownOutlined />}
                mode="tags"
                className="w-full"
                value={selectedIds}
                defaultValue={selectedIds}
                onChange={(e) => handleDropDowns(e, "management reports")}
              >
                {managementOptions.map((each: any) => {
                  return (
                    <Option value={each.id} key={each.id}>
                      {each.name}
                    </Option>
                  );
                })}
              </AntSelect>
            </div>
            <div className="pw-company-name flex flex-col gap-y-3 mt-10">
              <div className="pw-text-neutral-600 pw-font-14px">
                {t("Currency")}
              </div>
              <AntSelect
                className="pw-currency-pref pw-currency-select w-60"
                suffixIcon={
                  <CaretDownOutlined className="!pointer-events-none" />
                }
                showSearch
                placeholder="Select currency"
                value={currency}
                onChange={(e) => onChangeCurrency(e)}
                // onSearch={onSearch}
                filterOption={(input, option: any) => {
                  let currObj = currencies.find(
                    (opt: any) => opt.id === option.value
                  );
                  return (
                    currObj?.name
                      ?.toLowerCase()
                      ?.includes(input.toLowerCase()) ||
                    currObj?.symbol
                      ?.toLowerCase()
                      ?.includes(input.toLowerCase())
                  );
                }}
              >
                {currencies.map((eachCurrency: any) => (
                  <Option key={eachCurrency.id} value={eachCurrency.id}>
                    {eachCurrency.symbol}
                  </Option>
                ))}
              </AntSelect>
            </div>
            <div className="mt-10">
              <div className="pw-text-neutral-600 pw-font-14px">
                Select facility to allocate supplier emissions
              </div>
              <div>
                <AntSelect
                  className="pw-currency-pref pw-currency-select w-60 mt-2"
                  suffixIcon={
                    <CaretDownOutlined className="!pointer-events-none" />
                  }
                  showSearch
                  placeholder="Select facility"
                  value={allocationFacility}
                  onChange={(e) => onChangeCurrency(e)}
                  filterOption={(input, option: any) => {
                    let facilityObj = facilitiesList?.find(
                      (opt: any) => opt.id === option.value
                    );
                    return (
                      facilityObj?.name
                        ?.toLowerCase()
                        ?.includes(input.toLowerCase()) ||
                      facilityObj?.symbol
                        ?.toLowerCase()
                        ?.includes(input.toLowerCase())
                    );
                  }}
                >
                  {facilitiesList?.map((eachFacility: any) => (
                    <Option key={eachFacility.id} value={eachFacility.id}>
                      {eachFacility.name}
                    </Option>
                  ))}
                </AntSelect>
              </div>
            </div>
            <div className="pw-company-name flex flex-col gap-y-3 mt-10">
              <div className="pw-text-neutral-600 pw-font-14px">
                {t("GWP version")}
              </div>
              <AntSelect
                className="w-40"
                suffixIcon={<CaretDownOutlined />}
                value={gwpVersion}
                onChange={(e) => handleGWPVersionChange(e)}
              >
                <Option value="ar4" key="ar4">
                  AR4
                </Option>
                <Option value="ar5" key="ar5">
                  AR5
                </Option>
                <Option value="ar6" key="ar6">
                  AR6
                </Option>
              </AntSelect>
            </div>
            {/* <div className="pw-company-name flex flex-col gap-y-3 mt-10">
              <div className="pw-text-neutral-600 pw-font-14px">
                {"Multifactor Authentication"}
              </div>
              <div className="flex flex-row items-center gap-x-2">
                <Switch
                  style={{ color: "green" }}
                  checked={emailAuthEnabled}
                  onChange={(e) => setEmailAuthEnabled(e)}
                  size="small"
                />
                <div className="text-sm text-neutral-900">
                  Email Authentication
                </div>
              </div>
            </div> */}
          </div>
        </div>
        <div
          style={{ position: "absolute", bottom: "0", left: "0" }}
          className="flex flex-row justify-end w-full pw-bunit-footer gap-6"
        >
          <button
            className={`pw-bunit-button-primary pw-bunit-button-next text-white  font-bold ${
              validateSettingsForm()
                ? isLoading
                  ? "text-black bg-neutral-300"
                  : "cursor-pointer bg-primary"
                : "text-black bg-neutral-300"
            }`}
            onClick={() => handleSettingsSave()}
          >
            {isLoading ? (
              <div className="flex flex-row gap-2 p-2">
                <span>{t("Saving up")}</span>
                <CircularProgress size={20} />
              </div>
            ) : (
              <span>{t("Save")}</span>
            )}
          </button>
        </div>
      </div>
    </Fragment>
  );
};
export default OrganisationPreference;
